import { FC, useEffect, useState } from 'react';
import cn from 'classnames';

import DatePicker from 'common/form/pickers/DatePicker/DatePicker';
import TimePicker from 'common/form/pickers/TimePicker/TimePicker';

import { formatDateToDbFormat, formatTimeToDbFormat } from 'utils/dateUtil';

type Props = {
  value: string | null;
  disabled?: boolean;
  clearable?: boolean;
  error?: any;
  minDate?: string;
  maxDate?: string;
  onChangeDateTime: (value: string | null) => void;
  testId?: string;
  datePickerClassName?: string;
  timePickerClassName?: string;
  onBlur?: () => void;
};

const DateTimePicker: FC<Props> = ({
  value,
  testId,
  disabled,
  minDate,
  maxDate,
  clearable,
  error,
  onChangeDateTime,
  timePickerClassName,
  datePickerClassName,
  onBlur,
}) => {
  const [date, setDate] = useState(value ? formatDateToDbFormat(value) : null);
  const [time, setTime] = useState(value ? formatTimeToDbFormat(value) : null);

  useEffect(() => {
    if (value) {
      setDate(formatDateToDbFormat(value));
      setTime(formatTimeToDbFormat(value));
    } else {
      setDate(null);
      setTime(null);
    }
  }, [value]);

  const handleChangeTime = (changedTime: string | null) => {
    setTime(changedTime);
    if (date && changedTime) {
      onChangeDateTime(`${date}T${changedTime}`);
    } else if (changedTime === null) {
      onChangeDateTime(null);
    }
  };

  const handleChangeDate = (changedDate: string | null) => {
    setDate(changedDate);
    if (time && changedDate) {
      onChangeDateTime(`${changedDate}T${time}`);
    } else if (changedDate === null) {
      onChangeDateTime(null);
    }
  };

  return (
    <div className="d-flex">
      <DatePicker
        className={cn(datePickerClassName, 'w-picker mr-1')}
        testId={testId && `${testId}-date`}
        value={date}
        onChange={handleChangeDate}
        disabled={disabled}
        error={(time && !date) || error}
        minDate={minDate}
        maxDate={maxDate}
        clearable={clearable}
        onBlur={onBlur}
      />
      <TimePicker
        className={cn(timePickerClassName, 'w-picker')}
        testId={testId && `${testId}-time`}
        value={time}
        onChange={handleChangeTime}
        disabled={disabled}
        error={(date && !time) || error}
        clearable={clearable}
        onBlur={onBlur}
      />
    </div>
  );
};

export default DateTimePicker;
